module.exports = __webpack_public_path__ + "static/media/gql.feac3cf8.png";